import React, { useState } from 'react';
import { AlertTriangle, Eye, EyeOff } from 'lucide-react';
import HeaderOne from '../../../HeaderOne';
import Breadcrumb from '../../../Breadcrumb';

const Profile = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [profileData, setProfileData] = useState({
    name: 'Kunwar',
    email: 'keven3605y@gmail.com',
    mobileNumber: '',
    passkey: false,
    password: '**********',
    twoStepVerification: false
  });

  
  const [editingField, setEditingField] = useState(null);
  const [tempValue, setTempValue] = useState('');

  const handleEdit = (field) => {
    setEditingField(field);
    setTempValue(profileData[field]);
  };

  const handleSave = (field) => {
    setProfileData(prev => ({
      ...prev,
      [field]: tempValue
    }));
    setEditingField(null);
    setTempValue('');
  };

  const handleCancel = () => {
    setEditingField(null);
    setTempValue('');
  };

  const toggleFeature = (field) => {
    setProfileData(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  return (
    <>
    <HeaderOne/>

    {/* Breadcrumb */}
    <Breadcrumb />
    
    <div className="profile-page">
      <div className="profile-container">
        <div className="profile-card">
          {/* Name Field */}
          <div className="profile-field">
            <div className="field-content">
              <div className="field-info">
                <h3 className="field-label">Name</h3>
                {editingField === 'name' ? (
                  <div className="edit-input-group">
                    <input
                      type="text"
                      value={tempValue}
                      onChange={(e) => setTempValue(e.target.value)}
                      className="edit-input"
                      autoFocus
                    />
                    <div className="edit-actions">
                      <button onClick={() => handleSave('name')} className="save-btn">Save</button>
                      <button onClick={handleCancel} className="cancel-btn">Cancel</button>
                    </div>
                  </div>
                ) : (
                  <p className="field-value">{profileData.name}</p>
                )}
              </div>
              {editingField !== 'name' && (
                <button onClick={() => handleEdit('name')} className="edit-btn">Edit</button>
              )}
            </div>
          </div>

          {/* Email Field */}
          <div className="profile-field">
            <div className="field-content">
              <div className="field-info">
                <h3 className="field-label">Email</h3>
                {editingField === 'email' ? (
                  <div className="edit-input-group">
                    <input
                      type="email"
                      value={tempValue}
                      onChange={(e) => setTempValue(e.target.value)}
                      className="edit-input"
                      autoFocus
                    />
                    <div className="edit-actions">
                      <button onClick={() => handleSave('email')} className="save-btn">Save</button>
                      <button onClick={handleCancel} className="cancel-btn">Cancel</button>
                    </div>
                  </div>
                ) : (
                  <p className="field-value">{profileData.email}</p>
                )}
              </div>
              {editingField !== 'email' && (
                <button onClick={() => handleEdit('email')} className="edit-btn">Edit</button>
              )}
            </div>
          </div>

          {/* Mobile Number Field */}
          <div className="profile-field">
            <div className="field-content">
              <div className="field-info">
                <h3 className="field-label">Primary mobile number</h3>
                <div className="field-warning">
                  <AlertTriangle className="warning-icon" />
                  <p className="warning-text">
                    For stronger account security, add your mobile number. If there's an unusual sign-in, we'll text you and verify that it's really you.
                  </p>
                </div>
              </div>
              <button className="add-btn">Add</button>
            </div>
          </div>

          {/* Passkey Field */}
          <div className="profile-field">
            <div className="field-content">
              <div className="field-info">
                <h3 className="field-label">Passkey</h3>
                <div className="field-warning">
                  <AlertTriangle className="warning-icon" />
                  <p className="warning-text">
                    Sign in the same way you unlock your device by using your face, fingerprint, or PIN.
                  </p>
                </div>
              </div>
              <button className="setup-btn">Set up</button>
            </div>
          </div>

          {/* Password Field */}
          <div className="profile-field">
            <div className="field-content">
              <div className="field-info">
                <h3 className="field-label">Password</h3>
                <div className="password-display">
                  <span className="password-text">
                    {showPassword ? 'mypassword123' : '**********'}
                  </span>
                  <button 
                    onClick={() => setShowPassword(!showPassword)}
                    className="password-toggle"
                  >
                    {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                  </button>
                </div>
              </div>
              <button className="edit-btn">Edit</button>
            </div>
          </div>

          {/* 2-Step Verification */}
          <div className="profile-field">
            <div className="field-content">
              <div className="field-info">
                <h3 className="field-label">2-step verification</h3>
                <div className="field-warning">
                  <AlertTriangle className="warning-icon" />
                  <p className="warning-text">
                    Add a layer of security. Require a code in addition to your password.
                  </p>
                </div>
              </div>
              <button 
                onClick={() => toggleFeature('twoStepVerification')}
                className={`toggle-btn ${profileData.twoStepVerification ? 'active' : ''}`}
              >
                {profileData.twoStepVerification ? 'Turn off' : 'Turn on'}
              </button>
            </div>
          </div>

          {/* Compromised Account */}
          <div className="profile-field">
            <div className="field-content">
              <div className="field-info">
                <h3 className="field-label">Compromised account?</h3>
                <p className="field-description">
                  Take steps like changing your password and signing out everywhere.
                </p>
              </div>
              <button className="start-btn">Start</button>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .profile-page {
          min-height: 100vh;
          background-color: #f8fafc;
          padding: 2rem;
        }

        .profile-container {
          max-width: 800px;
          margin: 0 auto;
        }

        .profile-card {
          background: white;
          border-radius: 12px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        }

        .profile-field {
          border-bottom: 1px solid #e5e7eb;
          padding: 1.5rem 2rem;
        }

        .profile-field:last-child {
          border-bottom: none;
        }

        .field-content {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 2rem;
        }

        .field-info {
          flex: 1;
        }

        .field-label {
          font-size: 1.125rem;
          font-weight: 600;
          color: #df4928;
          margin-bottom: 0.5rem;
        }

        .field-value {
          color: #374151;
          margin: 0;
          font-size: 1rem;
        }

        .field-description {
          color: #6b7280;
          margin: 0;
          font-size: 0.95rem;
          line-height: 1.5;
        }

        .field-warning {
          display: flex;
          align-items: flex-start;
          gap: 0.5rem;
          margin-top: 0.5rem;
        }

        .warning-icon {
          width: 1rem;
          height: 1rem;
          color: #f59e0b;
          flex-shrink: 0;
          margin-top: 0.125rem;
        }

        .warning-text {
          color: #6b7280;
          margin: 0;
          font-size: 0.875rem;
          line-height: 1.4;
        }

        .password-display {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .password-text {
          color: #374151;
          font-family: monospace;
        }

        .password-toggle {
          background: none;
          border: none;
          color: #6b7280;
          cursor: pointer;
          padding: 0.25rem;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .password-toggle:hover {
          background-color: #f3f4f6;
        }

        .edit-input-group {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }

        .edit-input {
          padding: 0.75rem;
          border: 2px solid #e5e7eb;
          border-radius: 6px;
          font-size: 1rem;
          outline: none;
        }

        .edit-input:focus {
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .edit-actions {
          display: flex;
          gap: 0.5rem;
        }

        .save-btn, .cancel-btn {
          padding: 0.5rem 1rem;
          border-radius: 6px;
          font-size: 0.875rem;
          font-weight: 500;
          cursor: pointer;
          border: 1px solid transparent;
        }

        .save-btn {
          background-color: #3b82f6;
          color: white;
        }

        .save-btn:hover {
          background-color: #2563eb;
        }

        .cancel-btn {
          background-color: white;
          color: #6b7280;
          border-color: #d1d5db;
        }

        .cancel-btn:hover {
          background-color: #f9fafb;
        }

        .edit-btn, .add-btn, .setup-btn, .start-btn, .toggle-btn {
          padding: 0.75rem 1.5rem;
          border: 1px solid #d1d5db;
          background: white;
          border-radius: 20px;
          font-size: 0.875rem;
          font-weight: 500;
          color: #374151;
          cursor: pointer;
          transition: all 0.2s ease;
          min-width: 80px;
        }

        .edit-btn:hover, .add-btn:hover, .setup-btn:hover, .start-btn:hover {
          border-color: #9ca3af;
          background-color: #f9fafb;
        }

        .toggle-btn {
          color: #3b82f6;
          border-color: #3b82f6;
        }

        .toggle-btn:hover {
          background-color: #eff6ff;
        }

        .toggle-btn.active {
          background-color: #3b82f6;
          color: white;
        }

        .toggle-btn.active:hover {
          background-color: #2563eb;
        }

        @media (max-width: 768px) {
          .profile-page {
            padding: 1rem;
          }

          .profile-field {
            padding: 1rem;
          }

          .field-content {
            flex-direction: column;
            gap: 1rem;
            align-items: stretch;
          }

          .edit-btn, .add-btn, .setup-btn, .start-btn, .toggle-btn {
            align-self: flex-start;
          }
        }
      `}</style>
    </div>
    </>
  );
};

export default Profile;